/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import {
  ChipIcon,
  ClipboardListIcon,
  CollectionIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  DownloadIcon,
  HomeIcon,
  InboxIcon,
  KeyIcon,
  PhoneIcon,
  QuestionMarkCircleIcon,
  ReceiptTaxIcon,
  SearchIcon,
  StarIcon,
  UserGroupIcon,
  UserIcon,
  UsersIcon,
} from '@heroicons/react/solid';
import { makeStyles } from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import Tooltip from '@material-ui/core/Tooltip';
import Image from 'next/image';
import Link from 'next/link';
import Router, { useRouter } from 'next/router';
import React from 'react';
import Avatar from 'react-avatar';
import Loader from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { usageUpdate, userActions } from '../store/user';
import ajaxPromise from '../utils/ajaxPromise';

import Banner from './Banner';
import InviteBanner from './organizations/InviteBanner';
import NewInviteModal from './organizations/NewInviteModal';
import AccountInactiveModal from './pricing/AccountInactiveModal';

const sidebarNavigation = [
  {
    name: 'Dashboard',
    href: '/dashboard',
    icon: HomeIcon,
    description: 'Account overview and detailed usage statistics',
  },
  {
    name: 'Prospector',
    href: '/prospector',
    icon: SearchIcon,
    description: 'Identify target accounts and decision-makers, complete with 70+ attributes',
  },
  {
    name: 'Enrichment',
    href: '/enrich',
    icon: UsersIcon,
    description:
      'Turn any LinkedIn profile, email, or phone number into a full contact or company profile',
  },
  {
    name: 'Lists',
    href: '/saved-lists',
    icon: ClipboardListIcon,
    description: 'Organize your ideal contacts and companies into lists',
  },
  {
    name: 'Export Requests',
    href: '/export-requests',
    icon: DownloadIcon,
    description: 'Access all your export requests for contact/company information',
  },
  {
    name: 'Exact Match',
    href: '/exact-match',
    icon: CollectionIcon,
    description: 'Analyze and enrich your target account and contact lists',
  },
  {
    name: 'Team',
    href: '/organization',
    icon: UserGroupIcon,
    description: 'Invite team members and track credits consumption',
  },
  {
    href: '/integrations',
    name: 'Integrations',
    icon: ChipIcon,
    description: 'Push contacts and companies directly into your favorite CRM',
  },
  {
    href: '/verify-email',
    name: 'Email Verifier',
    icon: InboxIcon,
    description: 'Verify any external email address',
  },
  {
    href: '/pricing',
    name: 'Pricing',
    icon: CurrencyDollarIcon,
    description: 'ExactBuyer pricing plans',
  },
];
function SideBar({ classes, router }) {
  return (
    <div
      style={{ backgroundColor: '#000D36' }}
      className='w-28 z-20 h-screen overflow-y-auto custom-scroll-bar flex fixed top-0 left-0'
    >
      <div className='w-full py-1 mt-1 flex flex-col items-center'>
        <div className='shrink-0 flex items-center'>
          <a href='https://www.exactbuyer.com' className='cursor-pointer'>
            <img className='h-8 w-8' src='/exactbuyerlogonew.png' alt='' />
          </a>
        </div>
        <div className='flex-1 mt-5 w-full '>
          {sidebarNavigation.map((item) => (
            <Tooltip
              title={item?.description}
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 300 }}
              placement='right'
              classes={{
                tooltip: classes.dashboardTooltip,
                arrow: classes.customArrow,
              }}
              enterDelay={1500}
            >
              <div key={item.name}>
                <Link href={item.href}>
                  <div
                    style={
                      router.pathname.startsWith(item.href)
                        ? {
                            backgroundColor: '#244E9D',
                          }
                        : {}
                    }
                    className={classNames(
                      router.pathname.startsWith(item.href)
                        ? 'text-white hover:opacity-100 bg-indigo-500'
                        : 'text-white opacity-90 hover:opacity-100 nav-item-hover   hover:text-white',
                      `w-full flex flex-col items-center text-center border-b-1 text-xs font-normal cursor-pointer relative py-2.5`,
                    )}
                    aria-current={router.pathname.startsWith(item.href) ? 'page' : undefined}
                  >
                    {item.name === 'Prospector' && (
                      <span className='bg-exact-blue text-white absolute text-[12px] font-extralight rounded-full py-1 px-2 self-end top-1 right-1'>
                        New
                      </span>
                    )}
                    <item.icon className='h-5 w-5 heroicon-sw-1' aria-hidden='true' />
                    <span className='mt-2'>{item.name}</span>
                  </div>
                </Link>
              </div>
            </Tooltip>
          ))}
        </div>
      </div>
    </div>
  );
}

const allPagesMapping = [
  ...sidebarNavigation,
  {
    name: 'Integrations',
    href: '/integrations',
    title: 'Integrations',
  },
  { href: '/create-audience', name: 'Create Audience' },
  { href: '/list', name: 'View Match' },
  { href: '/company-exact-match', name: 'View Match' },
  { href: '/company-list', name: 'Company List' },
  { href: '/contact-list', name: 'Contact List' },
  { href: '/account', name: 'Account' },
  { href: '/pricing', name: 'Pricing' },
  { href: '/talk-to-sales', name: 'Talk to Sales' },
  { href: '/contact-export-request', name: 'Contact Export Request' },
  { href: '/company-export-request', name: 'Company Export Request' },
  { href: '/refer', name: 'Earn Free Credits' },
  { href: '/api-access', name: 'API' },
];

const dropDownMenu = [
  { href: '/account', name: 'Account', icon: UserIcon },
  { name: 'API', href: '/api-access', icon: KeyIcon },
  { href: '/pricing', name: 'Pricing', icon: CreditCardIcon },
  { href: '/talk-to-sales', name: 'Support', icon: QuestionMarkCircleIcon },
];

Router.events.on('routeChangeComplete', (url) => {
  window.analytics.page(url);
});

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

const useStyles = makeStyles({
  customTooltip: {
    backgroundColor: '#000000',
    fontSize: '0.8rem',
    lineHeight: '1.2rem',
  },
  dashboardTooltip: {
    backgroundColor: '#334155',
    fontSize: '0.8rem',
    lineHeight: '1.2rem',
  },
  customArrow: {
    color: '#000000',
  },
  smallFont: {
    fontSize: '0.8rem',
    lineHeight: '1.1rem',
  },
});

export default function Dashboard(props) {
  const [showPendingOrganizationInviteModal, setShowPendingOrganizationInviteModal] =
    React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [showBanner, setShowBanner] = React.useState(true);
  const [showAccountInactiveModal, setShowAccountInactiveModal] = React.useState(false);

  const [stripeForceRefresh, setStripeForceRefresh] = React.useState(false);

  const { user, loaded, organization } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const router = useRouter();

  const getTitle = (pathname) => {
    for (let index = 0; index < allPagesMapping.length; index += 1) {
      if (pathname.startsWith(allPagesMapping[index].href)) {
        if (allPagesMapping[index]?.title) {
          return allPagesMapping[index].title;
        }
        return allPagesMapping[index].name;
      }
    }
    return '';
  };
  const [mutationObserver, setMutationObserver] = React.useState(null);

  React.useLayoutEffect(() => {
    let divElement = document.getElementById('LU__root_ele');
    if (divElement) {
      divElement.remove();
    } else {
      const observer = new MutationObserver(() => {
        divElement = document.getElementById('LU__root_ele');
        if (divElement) {
          divElement.remove();
        }
      });
      observer.observe(document, { subtree: true, childList: true });
      setMutationObserver(observer);
    }
  }, []);

  React.useEffect(() => {
    if (mutationObserver) {
      const removeObserver = setTimeout(() => {
        mutationObserver?.disconnect();
        clearTimeout(removeObserver);
      }, 2 * 1000);
      setMutationObserver(null);
    }
  }, [mutationObserver]);

  React.useEffect(() => {
    dispatch(usageUpdate());
    ajaxPromise('/api/usage_stats', 'GET')
      .then((response) => {
        dispatch(userActions.updateOrganizationData(response.data));
      })
      .catch(() => {});
    ajaxPromise('/api/user/info', 'GET')
      .then((response) => {
        dispatch(userActions.loginSuccess(response?.data));
        if (response?.data?.pending_invite?.organization_name) {
          router.push('/organization');
          setShowPendingOrganizationInviteModal(true);
        } else if (response?.data?.free_trial && !response?.data?.free_trial.trial_active) {
          router.push('/pricing');
        }
      })
      .catch(() => {})
      .then(() => {
        dispatch(userActions.loaded());
      });
  }, []);

  React.useEffect(() => {
    if (!user && loaded && router.isReady) {
      router.push({
        pathname: '/signup',
        query: {
          fromPath: router.pathname,
          fromQuery: JSON.stringify(router.query),
        },
      });
    }
  }, [user, loaded, router.isReady]);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  React.useEffect(() => {
    if (
      user &&
      user?.limit_platform_access &&
      !['/account', '/pricing', '/talk-to-sales'].includes(router.pathname)
    ) {
      setShowAccountInactiveModal(true);
      router.push({
        pathname: '/pricing',
      });
    }
    if (router?.query?.stripe_refresh) {
      setStripeForceRefresh(true);
      router.replace({
        pathname: router.pathname,
      });
      const timer = setTimeout(() => {
        router.reload();
        setStripeForceRefresh(false);
      }, 3000);
    }
  }, [user, loaded, router.isReady, router.pathname]);

  const isRoot = user?.capabilities?.some((capability) => capability === 'ROOT_USER');

  const logout = () => {
    ajaxPromise('/api/logout', 'POST')
      .then(() => {
        dispatch(userActions.logoutSuccess());
        router.push({
          pathname: '/login',
          query: { disableAutoLogin: true },
        });
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const bannerVisible =
    !user?.is_team_member &&
    showBanner &&
    !user?.subscription &&
    loaded &&
    !user?.free_trial &&
    !user?.free_trial_already_availed &&
    !isRoot;
  const classes = useStyles();
  const getMemoisedTitle = React.useMemo(() => getTitle(router.pathname), [router.pathname]);

  return !loaded || !user || stripeForceRefresh ? (
    <div className='w-full h-screen flex bg-white items-center justify-center'>
      <Image width={80} height={80} src='/loading.svg' priority />
    </div>
  ) : (
    <>
      <AccountInactiveModal
        showModal={showAccountInactiveModal}
        setShowModal={setShowAccountInactiveModal}
      />
      <div>
        <div className='h-full bg-white overflow-hidden flex'>
          {navbarOpen && (
            <div className='md:hidden'>
              <div className='fixed inset-0 z-40 flex'>
                <div className='fixed inset-0' aria-hidden='true'>
                  <div className='absolute inset-0 bg-gray-600 opacity-75' />
                </div>
                <div className='absolute top-0 right-0 mr-2 pt-2 '>
                  <button
                    className='ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white'
                    type='button'
                    onClick={() => {
                      setNavbarOpen(false);
                    }}
                  >
                    <span className='sr-only'>Close sidebar</span>

                    <svg
                      className='h-6 w-6 text-white'
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                      aria-hidden='true'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M6 18L18 6M6 6l12 12'
                      />
                    </svg>
                  </button>
                </div>

                <div className='relative max-w-xs w-full bg-transparent pt-5 pb-4 flex-1 flex flex-col '>
                  <SideBar classes={classes} router={router} />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className='hidden md:flex '>
          <SideBar classes={classes} router={router} />
        </div>
        <div className='absolute top-0 left-0 md:ml-28 right-0 xl:px-0  min-h-screen'>
          <div className='w-full z-30 fixed shrink-0 h-12 bg-white border-b border-gray-200 flex'>
            <button
              className='border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden'
              type='button'
              onClick={() => setNavbarOpen(true)}
            >
              <span className='sr-only'>Open sidebar</span>
              <svg
                className='h-6 w-6'
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
                aria-hidden='true'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M4 6h16M4 12h16M4 18h7'
                />
              </svg>
            </button>
            <h1 className='text-base sm:text-xl font-semibold ml-2 md:ml-5 lg:ml-8 mt-2.5 sm:mt-2 pt-0.5 text-gray-700'>
              {getMemoisedTitle}
            </h1>
            <div className='absolute top-0 right-0 md:mr-28 pr-5'>
              <div className='flex justify-start'>
                <div className='flex mt-0.5  divide-x divide-gray-200 bg-white'>
                  <div
                    className={`${
                      user?.permission_profile?.ORGANIZATION_VIEW_ACCESS && 'hidden sm:block'
                    }`}
                  >
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                        arrow: classes.customArrow,
                      }}
                      title='Your allocated credits.'
                      TransitionComponent={Fade}
                      TransitionProps={{ timeout: 600 }}
                      arrow
                      interactive
                      placement='bottom'
                    >
                      <div className='mt-1.5 sm:mt-1 mr-1 sm:mr-2'>
                        <dt className='flex justify-end'>
                          <Link href='/account'>
                            <div
                              className={`sm:flex ${
                                user?.free_trial?.trial_active && 'mr-2'
                              } sm:justify-start p.1-5 sm:p-2 rounded-md hover:bg-indigo-50 cursor-pointer`}
                            >
                              <div className='mx-1 text-xs sm:text-sm sm:mx-2 font-semibold text-gray-600'>
                                Personal Credits
                              </div>
                              <div className='flex justify-start'>
                                <div className='text-exact-blue text-xs sm:text-sm mx-1 sm:mx-2 font-semibold'>
                                  {loaded ? (
                                    <>{user?.credits_remaining}</>
                                  ) : (
                                    <Loader
                                      type='TailSpin'
                                      color='#5046E4'
                                      height={24}
                                      width={24}
                                    />
                                  )}
                                </div>
                                {user?.credits_remaining < 10 ? (
                                  <div className='h-2 w-2 rounded-full sm:ml-1 bg-red-500' />
                                ) : (
                                  <>
                                    {user?.credits_remaining < 50 ? (
                                      <div className='h-2 w-2 rounded-full sm:ml-1 bg-yellow-500' />
                                    ) : (
                                      <div className='h-2 w-2 rounded-full sm:ml-1 bg-green-500' />
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </Link>
                        </dt>
                      </div>
                    </Tooltip>
                  </div>
                  {user?.permission_profile?.ORGANIZATION_VIEW_ACCESS && (
                    <Tooltip
                      classes={{
                        tooltip: classes.customTooltip,
                        arrow: classes.customArrow,
                      }}
                      title='The sum of all unused and unallocated credits for your team'
                      TransitionComponent={Fade}
                      TransitionProps={{ timeout: 600 }}
                      arrow
                      interactive
                      placement='bottom'
                    >
                      <div className=' sm:mt-1'>
                        <dt className='flex justify-end'>
                          <Link href='/account'>
                            <div className='sm:flex sm:justify-start p-1.5 sm:p-2 rounded-md hover:bg-indigo-50 cursor-pointer mx-1 sm:mx-2'>
                              <div className='text-xs sm:text-sm font-semibold text-gray-600'>
                                Team Credits
                              </div>
                              <div className='flex justify-start sm:ml-3'>
                                <div className='text-exact-blue text-xs sm:text-sm  font-semibold'>
                                  {loaded ? (
                                    <>{organization?.team_total_remaining_credits}</>
                                  ) : (
                                    <Loader
                                      type='TailSpin'
                                      color='#5046E4'
                                      height={24}
                                      width={24}
                                    />
                                  )}
                                </div>
                                {organization?.team_total_remaining_credits < 10 ? (
                                  <div className='h-2 w-2 rounded-full ml-1 bg-red-500' />
                                ) : (
                                  <>
                                    {organization?.team_total_remaining_credits < 50 ? (
                                      <div className='h-2 w-2 rounded-full ml-1 bg-yellow-500' />
                                    ) : (
                                      <div className='h-2 w-2 rounded-full ml-1 bg-green-500' />
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </Link>
                        </dt>
                      </div>
                    </Tooltip>
                  )}

                  {!user?.is_team_member && (
                    <div className='self-center items-center px-2 hidden lg:block '>
                      <Link href='/refer'>
                        <div className='flex justify-start px-2 rounded-md py-2 hover:bg-indigo-50 cursor-pointer'>
                          <div className='text-sm font-semibold text-exact-blue'>
                            Get Free Credits
                          </div>
                        </div>
                      </Link>
                    </div>
                  )}

                  {user?.free_trial?.days_remaining ? (
                    <div className='mt-1 hidden lg:block w-36 text-xs text-center px-1 pt-0.5 text-gray-600'>
                      <span className='font-bold'>
                        {`${user.free_trial?.days_remaining}`} day
                        {user.free_trial?.days_remaining !== 1 ? 's' : ''}
                      </span>{' '}
                      left in your free trial
                    </div>
                  ) : user?.free_trial?.hours_remaining ? (
                    <div className='mt-1 hidden lg:block w-36 text-xs text-center pl-3 pt-0.5 text-gray-600'>
                      <span className='font-bold'>
                        {`${user.free_trial.hours_remaining}`} hour
                        {user.free_trial.hours_remaining !== 1 ? 's' : ''}
                      </span>{' '}
                      left in your free trial
                    </div>
                  ) : (
                    <></>
                  )}

                  <div className='px-2 hidden lg:block'>
                    <div className='flex justify-center w-full'>
                      <Link href='/talk-to-sales'>
                        <button
                          type='button'
                          className='inline-flex items-center mt-1 px-2 py-2 border border-transparent bg-exact-blue hover:bg-blue-900 shadow-sm text-sm leading-4 font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                        >
                          <PhoneIcon className='-ml-0.5 mr-1 h-4 w-4' aria-hidden='true' />
                          Book a Demo
                        </button>
                      </Link>
                    </div>
                  </div>

                  <div className='hidden lg:block'>
                    <Link href='/pricing'>
                      <div className='inline-flex items-center cursor-pointer mt-1 hover:bg-indigo-50 px-2 mx-2 py-2 text-sm font-semibold rounded-md text-exact-blue hover:text-blue-900 bg-white '>
                        {user?.is_team_member ? (
                          <>
                            <ReceiptTaxIcon className='-ml-1  mr-1 h-5 w-5 text-blue-800' />
                            Get More Credits
                          </>
                        ) : (
                          <>
                            <StarIcon className='-ml-1  mr-1 h-5 w-5 text-yellow-400' />
                            Upgrade
                          </>
                        )}
                      </div>
                    </Link>
                  </div>
                </div>
                <div
                  onMouseEnter={() => {
                    // setTimeout(() => setMenuOpen(true), 100);
                    if (window.innerWidth > 800) {
                      setMenuOpen(true);
                    }
                  }}
                  onMouseLeave={() => {
                    setTimeout(() => setMenuOpen(false), 100);
                  }}
                  onClick={() => {
                    if (window.innerWidth <= 800) {
                      setMenuOpen(!menuOpen);
                    }
                  }}
                >
                  <button
                    type='button'
                    className='max-w-xs flex items-center text-sm rounded-full focus:outline-none mt-2'
                    id='user-menu'
                    aria-haspopup='true'
                  >
                    <span className='sr-only'>Open user menu</span>
                    <Avatar name={user?.name} round size='30' />
                  </button>
                  {menuOpen && (
                    <div
                      className='transition duration-500 ease-in-out origin-top-right absolute right-0 mr-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 py-1 focus:outline-none'
                      role='menu'
                      aria-orientation='vertical'
                      aria-labelledby='user-menu'
                    >
                      {dropDownMenu.map((obj) => (
                        <Link href={obj.href} key={obj.href}>
                          <div
                            className='block py-2 px-4 cursor-pointer hover:bg-indigo-50 text-gray-700 hover:text-indigo-600'
                            role='menuitem'
                          >
                            <div className='flex flex-wrap content-start'>
                              <obj.icon className='h-5 w-5 mr-2' />

                              <div className='text-sm'>{obj.name}</div>
                            </div>
                          </div>
                        </Link>
                      ))}
                      <hr />
                      <button
                        type='button'
                        className=' g_id_signout block py-2 px-4 text-sm text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 cursor-pointer w-full'
                        role='menuitem'
                        onClick={() => {
                          logout();
                          setMenuOpen(false);
                        }}
                      >
                        <div className='flex flex-wrap content-start'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            className='h-5 w-5 mr-2 text-red-500'
                            fill='none'
                            viewBox='0 0 24 24'
                            stroke='currentColor'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1'
                            />
                          </svg>

                          <div className='text-sm  '>Log out</div>
                        </div>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='bg-gray-100'>
            <main className='flex-1 relative overflow-y-auto focus:outline-none mt-12'>
              {user?.pending_invite?.invited_by && (
                <InviteBanner
                  invitedBy={user?.pending_invite?.invited_by}
                  organizationName={user?.pending_invite?.organization_name}
                />
              )}
              {bannerVisible && (
                <Banner
                  text='Start your free trial today and find your next best customers.'
                  buttonText='See Plans'
                  buttonLink='/pricing'
                  hideButton={router.pathname === '/pricing'}
                  setShowBanner={setShowBanner}
                />
              )}
              {user?.free_trial && !user?.free_trial?.trial_active && showBanner && (
                <Banner
                  text='Upgrade to a paid plan or extend your free trial by booking a demo.'
                  buttonText='Book a demo'
                  buttonLink='/talk-to-sales'
                  setShowBanner={setShowBanner}
                />
              )}
              <div className='mx-0'>{props.content}</div>
            </main>
          </div>
        </div>
      </div>
      <NewInviteModal
        showModal={showPendingOrganizationInviteModal}
        setShowModal={setShowPendingOrganizationInviteModal}
        invitedBy={user?.pending_invite?.invited_by}
        organizationName={user?.pending_invite?.organization_name}
      />
    </>
  );
}
